export default "__VITE_ASSET__ad9076c8__"